import React from "react";
import { useRecommendationStore } from "../../stores/recommendationStore";
import { WAREHOUSE_OPTIONS } from "../../utils/warehouses";

// Компонент для вибору магазину
const RecommendationTablesPickPanel = React.memo(() => {
  // Отримуємо дані та дії зі стору рекомендацій
  const currentWarehouseId = useRecommendationStore(
    (state) => state.filters.warehouse_id
  );
  const setWarehouse = useRecommendationStore((state) => state.setWarehouse);

  // Обробник кліку на магазин
  const handleClick = (warehouseId) => {
    setWarehouse(warehouseId);
  };

  return (
    <div className="tables-pick-panel">
      {WAREHOUSE_OPTIONS.map((warehouse) => (
        <button
          key={warehouse.id}
          className={`focus-button ${
            currentWarehouseId === warehouse.id ? "active" : ""
          }`}
          onClick={() => handleClick(warehouse.id)}
        >
          <div className="check"></div>
          {warehouse.name}
        </button>
      ))}
    </div>
  );
});

export default RecommendationTablesPickPanel;
